// extracted by mini-css-extract-plugin
module.exports = {"selectGroup":"select-group_selectGroup__ZtsFD","menuItem":"select-group_menuItem__3BqSk"};